/**
 * Host-side helpers for /api/live-watch endpoints.
 *
 * Flow:
 *   1) startLiveWatch(snapshot) → { shortId, hostToken }  (cached locally per match)
 *   2) pushLiveWatch(shortId, hostToken, snapshot)        (call on every score tick)
 */
import { getShadowId } from './localStore';

const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || '').replace('http://', 'https://');

export async function startLiveWatch({ sideA, sideB, presetName, bestOf }) {
  const res = await fetch(`${BACKEND_URL}/api/live-watch/start`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      shadow_id: getShadowId(),
      side_a: sideA,
      side_b: sideB,
      preset_name: presetName,
      best_of: bestOf,
    }),
  });
  if (!res.ok) throw new Error(`live-watch/start ${res.status}`);
  return res.json();
}

export async function pushLiveWatch(shortId, hostToken, { games, currentGameIdx, winner }) {
  if (!shortId || !hostToken) return;
  try {
    await fetch(`${BACKEND_URL}/api/live-watch/${shortId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'X-Host-Token': hostToken,
      },
      body: JSON.stringify({
        games,
        current_game_idx: currentGameIdx,
        winner,
      }),
      keepalive: true,
    });
  } catch (err) {
    if (process.env.NODE_ENV !== 'production') console.debug('[live-watch] push failed:', err?.message);
  }
}

export function watchUrl(shortId) {
  return `${window.location.origin}/watch/${shortId}`;
}
